import api from '@/apis'
import downloader from 'js-file-download'

export default {
  state: {
    loading: false,
    headers: [
      { text: 'Log ID', value: 'log_id', sortable: false },
      { text: 'User ID', value: 'user_id', sortable: false },
      { text: 'User', value: 'username', sortable: false },
      { text: 'Action', value: 'action', sortable: false },
      { text: 'Log Datetime', value: 'datetime', sortable: false }
    ],
    items: [],
    search: null,
    total_items: null,
    options: null
  },
  mutations: {
    SET_LOGS_LOADING(state, payload) {
      state.loading = payload
    },
    SET_LOGS_ITEMS(state, payload) {
      state.items = payload
    },
    SET_LOGS_SEARCH(state, payload) {
      state.search = payload
    },
    SET_LOGS_TOTAL_ITEMS(state, payload) {
      state.total_items = payload
    },
    SET_LOGS_OPTIONS(state, payload) {
      state.options = payload
    }
  },
  actions: {
    async fetchLogRecords({ commit, state }) {
      try {
        commit('SET_LOGS_ITEMS', [])
        commit('SET_LOGS_LOADING', true)
        commit('SET_LOGS_TOTAL_ITEMS', 0)

        const { page, itemsPerPage } = state.options
        const response = await api.getLogs({ search: state.search, limit: itemsPerPage, offset: page * itemsPerPage - itemsPerPage })

        if (response.data.success) {
          commit('SET_LOGS_LOADING', false)
          commit('SET_LOGS_ITEMS', response.data.data.logs)
          commit('SET_LOGS_TOTAL_ITEMS', response.data.total)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_LOGS_LOADING', false)
      }
    },
    async exportLogRecords({ commit, state }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Exporting Log', loading: true })
        const { page, itemsPerPage } = state.options
        const response = await api.downloadLogs({ format: 'xlsx', search: state.search, limit: itemsPerPage, offset: page * itemsPerPage - itemsPerPage })
        if (response.data) {
          downloader(response.data, response.headers.filename)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
